/** Browser timers clamp larger delays; bounding avoids a long block becoming a hot timer loop. */
export const MAX_PROFILE_BLOCK_TIMER_MS = 2_147_483_647;

export function profileBlockDelay(blockedUntil: number, now: number): number {
  return Math.min(Math.max(0, blockedUntil - now + 10), MAX_PROFILE_BLOCK_TIMER_MS);
}
